<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import axios from 'axios'
import appConfig from '@src/app.config'
import { authComputed, userMethods } from '@state/helpers'
import ImageInput from '@components/image-uploader.vue'
import mapApiUrl from '@/src/utils/api-mapper'
import store from '@state/store'

export default {
  page: {
    title: 'Profile',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader,  
  ImageInput },
  data () {
    return {
      title: 'Profile',
      items: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Profile',
          active: true
        },
      ],
      profile: '',
      avatar: null,
      openProfile: false,
      accountTypes: [{index:1, name:'Administrator'},
                    {index:2, name:'Planner'},
                    {index:3, name:'Engineer'},
                    {index:4, name:'Company Man'},
                    {index:5, name:'Geologist'},
                    {index:6, name:'Management'}, ],
      accountType: ''
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
    this.avatar = { imageURL: this.currentUser.avatar }
    this.accountType = this.accountTypes.find(x => x.index === this.currentUser.roleId)
    if (this.accountType === undefined) this.accountType = 'Rigsis'
  },
  methods: {
    ...userMethods,
    save() {
      /* const data = {
        avatar: this.avatar.file
      }
      this.changeAvatar({params: data}) */
      const url = mapApiUrl('/api/identity/user/change_avatar')
      axios
      .post(url, this.avatar.formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }) 
      .then((response) => {
        if (response.data.data) {
          store.dispatch('auth/setAvatar', response.data.data.avatar)
          this.avatar.imageURL = response.data.data.avatar
          this.makeToast("Avatar has been changed")
        }
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card-box d-flex flex-column text-center">
          <div class="avatar-selector">
            <ImageInput v-model="avatar">
              <div slot="activator">
                <b-avatar :src=avatar.imageURL :alt="currentUser.username" size="300px" />              
                <div class="avatar-selector-area">
                  <div class="text">
                    <i class="mdi mdi-camera"></i>
                    Change
                  </div>
                </div>
              </div>
            </ImageInput>
          </div>
          <div class="text-center">
            <b-button v-show="avatar.imageURL !== currentUser.avatar" variant="primary" @click="save">Save</b-button>
          </div>
          <div class="text-left mt-3">
            <h4 class="font-13 text-uppercase">About Me :</h4>
            <p class="text-muted mb-2 font-13">
              <strong>Full Name :</strong>
              <span class="ml-2">
                {{currentUser.fullName}}
              </span>
            </p>

            <p class="text-muted mb-2 font-13">
              <strong>Email :</strong>
              <span class="ml-2">{{currentUser.username}}</span>
            </p>
            <p class="text-muted mb-2 font-13">
              <strong>Account type :</strong>
              <span class="ml-2">{{accountType.name}}</span>
            </p>
          </div>
        </div>
        <!-- end card-box -->
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss">
.avatar-selector {
  position: relative;
  align-self: center;
  &-area {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    opacity: 0;
    border-radius: 50%;
    &:hover {
      opacity: 0.7;
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      bottom: 100px;
      align-items: center;
      background-color: black;
      color: white;
      width: 100%;
      height: 48px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      cursor: pointer;
      line-height: 1;
    }
  }
}
</style>